import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons"
import useOutsideClick from "../hooks/useOutsideClick"

export const HelpBubble = ({
  title,
  children,
}: {
  title: string
  children: any
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const outsideClickRef = useOutsideClick(() => {
    setIsOpen(false)
    return true
  })

  useEffect(() => {
    if (!isOpen) return
    const onKeyDown = (e: KeyboardEvent) =>
      e.key == "Escape" && setIsOpen(false)
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [isOpen])

  return (
    <>
      <div className="cursor-pointer" onClick={() => setIsOpen(true)}>
        <FontAwesomeIcon
          icon={faQuestionCircle}
          className="text-gray-700 dark:text-gray-300"
        />
      </div>
      {isOpen && (
        <div className="z-50 fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-25 flex flex-col">
          <div
            className="min-h-0 grow md:flex-grow-0 overflow-y-scroll mt-8 mb-24 md:mt-36 w-4/5 md:max-w-3xl mx-auto p-4 md:p-8 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 prose dark:prose-invert prose-sm"
            ref={outsideClickRef}
          >
            <h2>{title}</h2>
            {children}
          </div>
        </div>
      )}
    </>
  )
}

export const HelpInline = ({
  children,
  title,
}: {
  title: string
  children: any
}) => {
  return (
    <div className="hidden md:block p-4 md:p-8 md:pt-6 text-gray-600 dark:text-gray-300 prose dark:prose-invert prose-sm">
      <h2>{title}</h2>
      {children}
    </div>
  )
}
